import { render } from "./resetPassword.vue?vue&type=template&id=fe35f8ac&scoped=true"
import script from "./resetPassword.vue?vue&type=script&lang=ts"
export * from "./resetPassword.vue?vue&type=script&lang=ts"

import "./resetPassword.vue?vue&type=style&index=0&id=fe35f8ac&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-fe35f8ac"

export default script